import { ChangeDetectorRef, EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { MatStepper } from '@angular/material/stepper';
import { DataSourceType, DataSourceTypeUtil } from 'src/app/domainObjects/dataSourceType';
import { StepModel } from '../../ingest/ingest-work-flow-layout/ingest-work-flow-layout.component';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { OptionItem } from 'src/app/model/optionItem';
import { ColumnMapDefinitionModel } from 'src/app/model/columnMapDefinitionModel';
import { DataDictionaryService, DataDictionaryItem } from '../../../../services/dataDictionary/data-dictionary.service';
import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import { DataDictionaryType } from 'src/app/domainObjects/dataDictionaryType';
import { UserDataService } from 'src/app/services/user-data-service';
import { DataConnectorType, FeatherDataConnectorInfo, FileDataConnectorInfo, ParaquetDataConnectorInfo } from 'src/app/domainObjects/dataConnector';
import { FileDataConnectorViewModel } from 'src/app/views/connectors/file/file-data-connector/file-data-connector.component';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { BaseComponent } from 'src/app/base/base.component';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { SharedService } from 'src/app/services/shared.service';
import { UpdateingestnodestatusService } from 'src/app/services/updateingestnodestatus.service';
import { ColoredTextItem } from 'src/app/domainObjects/coloredTextItem';
import { FeatherDataConnectorViewModel } from 'src/app/views/connectors/feather/feather.component';
import { ParquetDataConnectorViewModel } from 'src/app/views/connectors/parquet-data-connector/parquet-data-connector.component';

export class TargetColumnChangedEventData {
  ingestConfig: IngestConfigViewModel;
  columnName: string;
  targetColumnName: string;
  isTargetColSetManually: boolean;
}

@Component({
    selector: 'app-mapper-flow-layout',
    templateUrl: './mapper-flow-layout.component.html',
    styleUrls: ['./mapper-flow-layout.component.css'],
    standalone: false
})
export class MapperFlowLayoutComponent extends BaseComponent implements OnInit {
  @Input() ingestConfig: IngestConfigViewModel;
  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() stepModel: StepModel;
  @Input() configWorkflowStepper: MatStepper;
  @Output() targetColumnChanged = new EventEmitter<TargetColumnChangedEventData>();

  dataSourceTypeUtil = DataSourceTypeUtil;
  dataSource?: MatTableDataSource<ColumnMapDefinitionModel> = null;
  displayedColumns: string[] = ['index', 'name', 'targetColumnName', 'dataType', 'pyDataType', 'description'];
  targetColumns: OptionItem[] = [];
  dataDictionaryItems: DataDictionaryItem[];
  columnDefs: ColumnMapDefinitionModel[];
  private hasRowsSubject = new BehaviorSubject<boolean>(false);
  hasRows = this.hasRowsSubject.asObservable();
  defaultTargetColumn = 'Select a Target Column';
  newPlaceholderColumnName = "";
  disabledColumns:any;
  options: string[] =[];
  // selectedItem: ColoredTextItem = {
  //   color: 'blue',
  //   text: '',
  // };
def: any;
  constructor(private dataDictService: DataDictionaryService,
              private userData: UserDataService,
              private configViewModelService: ConfigViewModelService,
              private changeDet: ChangeDetectorRef,
              private sharedService: SharedService,
              private updateingestnodestatusService: UpdateingestnodestatusService,
              matDialog: MatDialog,
              errorLogger: ErrorReportingService) {
                super(errorLogger, matDialog);}
             
  

  ngOnInit(): void {
    // Extract the targetColumnNames from columnMap
    this.disabledColumns = this.ingestConfig.columnMap.map(item => item.targetColumnName);
    this.options=[...this.targetColumns.map(col => col.text).sort((a, b) => a.localeCompare(b))];
    
    //console.log("options===",  this.options);
       //console.log("targetColumns===",  this.targetColumns);
  }
  
  // Method to determine if an option should be disabled
  isOptionDisabled(item: any): boolean {
    // Check if the option's text is in the set of disabled column names
    // console.log('isOptionDisabled value: ', item );
    return this.disabledColumns.has(item);
  }

  onTargetColumnChanged(value: ColumnMapDefinitionModel, event: any): void {
     //this.disabledColumns = new Set(this.ingestConfig.columnMap.map(item => item.targetColumnName));
    // this.isOptionDisabled(value.targetColumnName);
    if (value.targetColumnName) {
      // TODO: Ensure we have mapped required fields before setting our step to complete
      this.stepModel.isComplete = true;

      // load the data type and description
      const dataDictItem = this.dataDictionaryItems.filter(i => i.Field === value.targetColumnName)[0];
      
      value.dataType = dataDictItem?.DataType;
      value.pyDataType = dataDictItem?.PyDataType;
      value.description = dataDictItem?.Description;
    } else {
      value.dataType = null;
      value.pyDataType = null;
      value.description = null;
    }
    
    const eventData = new TargetColumnChangedEventData();
    eventData.ingestConfig = this.ingestConfig;
    eventData.targetColumnName = value.targetColumnName;
    eventData.columnName = value.columnName;
    if(event !== null) {
      eventData.isTargetColSetManually = true;
    } else {
      eventData.isTargetColSetManually = false;
    }
    if(event !== null) {
      //Update the Ingest Node Status
      // this.updateingestnodestatusService.invokeUpdateIngestNodeStatus();
      this.sharedService.sendEvent("mapper_updated");
    }
    this.targetColumnChanged.emit(eventData);
    this.getDisabledColumns();
  }

  onTargetColumnCleared(def: any, value: string) {
      if (!value || value.trim() === '') {
        console.log('Target column removed');
        def.targetColumnName = '';
        def.dataType = null;
        def.pyDataType = null;
        def.description = null;
        this.sharedService.sendEvent("mapper_updated");
      }
  }


  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async onStepCompleted(completed: boolean): Promise<void> {
    this.stepModel.isComplete = completed;
    if (completed) {
      await this.delay(500);
      this.configWorkflowStepper.next();
    }
  }

  ngOnChanges(changes: any): void {
    // console.log(`ColumnMappingLayout::onChanges`);
    // console.log(changes);

    if (changes.ingestConfig) {
      if (changes.ingestConfig.firstChange === true || !changes.ingestConfig.previousValue) {
        this.refreshLayout();
        return;
      }

      if (changes.ingestConfig.previousValue === changes.ingestConfig.currentValue) {
        return;
      }

      if (changes.ingestConfig.previousValue !== changes.ingestConfig.currentValue) {
        this.refreshLayout();
      }
    }
  }

  async refreshLayout(typeOfLoad?:string): Promise<void> {
     this.ingestConfig.columnMap.forEach(item => {
      if (item.columnName.startsWith("Placeholder_")) {
        item.showPlaceholderDelbtn = true;
      }
    });

    switch (this.ingestConfig.targetDataFarm) {
        case DataFarmType.activity:
          this.dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.activity);
          this.targetColumns = this.dataDictionaryItems.map( i => new OptionItem(1, i.Field));
          break;
        case DataFarmType.subTask:
          this.dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.subTask);
          this.targetColumns = this.dataDictionaryItems.map( i => new OptionItem(1, i.Field));
          break;
        case DataFarmType.task:
          this.dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.task);
          this.targetColumns = this.dataDictionaryItems.map( i => new OptionItem(1, i.Field));
          break;
        case DataFarmType.users:
          this.dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.user);
          this.targetColumns = this.dataDictionaryItems.map( i => new OptionItem(1, i.Field));
          break;
        case DataFarmType.cases:
          this.dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.case);
          this.targetColumns = this.dataDictionaryItems.map( i => new OptionItem(1, i.Field));
          break;
        case DataFarmType.behaviors:
          this.dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.behavior);
          this.targetColumns = this.dataDictionaryItems.map( i => new OptionItem(1, i.Field));
          break;

           case DataFarmType.master:
          this.dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.master);
          this.targetColumns = this.dataDictionaryItems.map( i => new OptionItem(1, i.Field));
          break;
    }

    const configJsonObject = this.userData.getSelectedConfigJson(); //state.config;
    if(configJsonObject){
      var savedIngestConfig = configJsonObject.dataConnectorMappings[0];//.filter( item => item.guid === this.ingestConfig?.guid)[0];
    }
    this.dataTransformConfigViewModel.selectedIngestFarmGuid = this.ingestConfig.guid

    this.ingestConfig.matchAllColumns = false ;
    this.ingestConfig.notMatchingColumns = []

    if(savedIngestConfig?.columnMap){
      for (let column of this.ingestConfig.columnMap) {
        for (let source of savedIngestConfig.columnMap) {
          if (column.columnName == source.sourceColumn) {
            this.ingestConfig.matchAllColumns =  true;
            break; // Stop further iteration once matched
          }
        }
        if (this.ingestConfig.columns.includes(column.columnName) ) {
          // Do not do
        } else {
          this.ingestConfig.notMatchingColumns.push(column.columnName)
        } 
      
      }
    }

    if(typeOfLoad == 'Previous'){
      let incrementalIndex = 0; // Initialize an incremental index counter

      if(savedIngestConfig.dataConnector.dataConnectorType == 3){

        this.ingestConfig.dataConnector.inputFileName = savedIngestConfig.dataConnector.filePath ;
        this.ingestConfig.dataConnector.delimiter = savedIngestConfig.dataConnector.delimiter ;
        new FileDataConnectorViewModel( new FileDataConnectorInfo( savedIngestConfig.dataConnector.filePath, '', savedIngestConfig.dataConnector.delimiter, savedIngestConfig.dataConnector.connectionTimeOut,savedIngestConfig.dataConnector.selectedInstance,savedIngestConfig.dataConnector.nValue,savedIngestConfig.dataConnector.isUseFtp,savedIngestConfig.dataConnector.ftpService) ) ;
        this.dataTransformConfigViewModel.dataTransformerConfig.dataConnectorMappings[0].id = 100 ;
      }
      
      else if(savedIngestConfig.dataConnector.dataConnectorType == 4){
        this.ingestConfig.dataConnector.inputFileNameExcel = savedIngestConfig.dataConnector.filePath ;
        this.ingestConfig.dataConnector.sheetName = savedIngestConfig.dataConnector.sheetName ;
        this.ingestConfig.dataConnector.sheets = savedIngestConfig.dataConnector.sheets ;
        
      }
      else if(savedIngestConfig.dataConnector.dataConnectorType == 5){

        this.ingestConfig.dataConnector.inputFileName = savedIngestConfig.dataConnector.filePath ;
        new FeatherDataConnectorViewModel( new FeatherDataConnectorInfo( savedIngestConfig.dataConnector.filePath, '', savedIngestConfig.dataConnector.connectionTimeOut, savedIngestConfig.dataConnector.selectedInstance, savedIngestConfig.dataConnector.nValue, savedIngestConfig.dataConnector.isUseFtp, savedIngestConfig.dataConnector.ftpService) ) ;
        this.dataTransformConfigViewModel.dataTransformerConfig.dataConnectorMappings[0].id = 100 ;
        // this.sharedService.sendEvent(this.ingestConfig);

      }
      else if(savedIngestConfig.dataConnector.dataConnectorType == 6){

        this.ingestConfig.dataConnector.inputFileName = savedIngestConfig.dataConnector.filePath ;
        new ParquetDataConnectorViewModel( new ParaquetDataConnectorInfo( savedIngestConfig.dataConnector.filePath, '', savedIngestConfig.dataConnector.connectionTimeOut, savedIngestConfig.dataConnector.selectedInstance, savedIngestConfig.dataConnector.nValue,savedIngestConfig.dataConnector.inputFileNameFileScheduleDirectory,savedIngestConfig.dataConnector.baseFileName,savedIngestConfig.dataConnector.isUseFtp,savedIngestConfig.dataConnector.ftpService) ) ;
        this.dataTransformConfigViewModel.dataTransformerConfig.dataConnectorMappings[0].id = 100 ;
        // this.sharedService.sendEvent(this.ingestConfig);

      }
      this.configViewModelService.setDataTransformConfigViewModel(this.dataTransformConfigViewModel);
      this.changeDet.detectChanges();
      this.sharedService.sendEvent(this.ingestConfig);
    }

    this.ingestConfig.columnMap?.forEach(c => this.onTargetColumnChanged(c, null));
    this.targetColumns.sort( (a, b) => a.text < b.text ? -1 : 0);
    this.hasRowsSubject.next(this.ingestConfig.hasColumns());
    this.columnDefs = this.ingestConfig.columnMap;
    this.dataSource = new MatTableDataSource<ColumnMapDefinitionModel>();
    this.dataSource.data = this.columnDefs;
  }

  deleteThePlaceholderRow(def: any): void{
     this.showConfirmDialog(
      'Delete Confirmation', // Title of the dialog
      'Are you sure you want to delete this column?', // Message of the dialog
      async (result) => {
        if (result) { // Delete the row with Placeholder column only if the analyst confirms (result is true)
          // Delete the row with Placeholder column.
          const actualIndex = this.ingestConfig.columnMap.findIndex(colMap => colMap.index == def.index) // Actual Index of the element of the columnMap of the ingestConfig.
          if(actualIndex !== -1) {
            let removedPlaceholderRow = this.ingestConfig.columnMap.splice(actualIndex, 1);
            // Resets the indexes of the remaining elements of the coloumnMap array.
            this.updateIndexOfRemaingRowsPlchdr(actualIndex);
            this.refreshLayout(); // Refreshes the mapper layout.
          }
        }
      }
    );
  }

  //Update the Remaining Placeholder Rows after deletion of any Placeholder Row.
  updateIndexOfRemaingRowsPlchdr(removedPlacehldrRowIndex: number): void {
     for(var i = removedPlacehldrRowIndex; i < this.ingestConfig.columnMap.length; i++) {
        this.ingestConfig.columnMap[i].index--;
        this.ingestConfig.columnMap[i].id = this.ingestConfig.columnMap[i].id--;
        this.ingestConfig.columnMap[i].columnName = "Placeholder_"+this.ingestConfig.columnMap[i].id;
     }
  }

  handleMoveToField(direction: 'forward' | 'reverse', index: number) {
    if (direction  === 'reverse') {
      this.focusPreviousInput(index);
    } else {
      this.focusNextInput(index);
    }
  }

  focusNextInput(index: number) {
    const nextElement = document.querySelectorAll('app-autocomplete-field input')[index + 1];
    if (nextElement) {
      (nextElement as HTMLElement).focus();
    }
  }
  focusPreviousInput(index: number) {
    const previousElement = document.querySelectorAll('app-autocomplete-field input')[index - 1];
    if (previousElement) {
      (previousElement as HTMLElement).focus();
    }
  }
  getDisabledColumns(){
    this.disabledColumns = this.ingestConfig.columnMap.map(item => item.targetColumnName);
  }
}
